import { useState, useEffect, Fragment } from "react";
import FleetWebApi from "../Api/FleetWebApi";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Grid from "@mui/material/Grid";
import Moment from "react-moment";
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";
import { Button, Paper, TableHead } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import BadShuttieSummary from "./BadShuttieSummary";
import IconButton from "@mui/material/IconButton";
import { NavLink } from "react-router-dom";

function BadShuttieReport(props) {
  const [report, setReport] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [take] = useState(50);
  const [skip, setSkip] = useState(0);
  const [confirmedReceived, setConfirmedReceived] = useState(true);
  const [confirmedReworked, setConfirmedReworked] = useState(true);
  const [refresh, setRefresh] = useState(true);
  const [serialNumberSearch, setSerialNumberSearch] = useState("");
  const [emailSearch, setEmailSearch] = useState("");

  const handleContactButtonPress = (serialNumber) => {
    FleetWebApi.setBadShuttieContacted(serialNumber)
      .then((resp) => {
        if (resp) {
          setRefresh(!refresh)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleRecievedPress = (serialNumber) => {
    FleetWebApi.setBadShuttieReceived(serialNumber)
      .then((resp) => {
        if (resp) {
          setRefresh(!refresh)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleReworkedPress = (serialNumber) => {
    FleetWebApi.setBadShuttieReworked(serialNumber)
      .then((resp) => {
        if (resp) {
          setRefresh(!refresh)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const nextPage = () => {
    setSkip(skip + take);
  };

  const previousPage = () => {
    setSkip(skip - take);
  };

  useEffect(() => {
    setIsLoading(true);
    FleetWebApi.getShuttieCommsReport(
      take,
      skip,
      { confirmedReworked, confirmedReceived },
      serialNumberSearch,
      emailSearch
    )
      .then((response) => {
        setReport(response);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setError(error.message);
        setIsLoading(false);
      });
  }, [
    skip,
    take,
    confirmedReceived,
    confirmedReworked,
    refresh,
    serialNumberSearch,
    emailSearch,
  ]);

  return (
    <Fragment>
      <h1>Shuttie Comms Issue Tracking</h1>
      <h2>Summary</h2>

      <BadShuttieSummary />
      {error && <p>Error Loading Data: {error}</p>}
      <h3>Filter</h3>

      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={3}>
          <Button
            onClick={() => {
              setConfirmedReceived(!confirmedReceived);
            }}
            color="primary"
            variant="contained"
            disabled={isLoading}
            className={confirmedReceived ? "buttonSuccess" : ""}
          >
            Include Received
          </Button>
        </Grid>
        <Grid item xs={12} md={12} lg={3}>
          <Button
            onClick={() => {
              setConfirmedReworked(!confirmedReworked);
            }}
            color="primary"
            variant="contained"
            disabled={isLoading}
            className={confirmedReworked ? "buttonSuccess" : ""}
          >
            Include Reworked
          </Button>
        </Grid>
        <Grid item xs={12} md={12} lg={3}>
          <TextField
            label="Serial Number Search"
            onChange={(e) => setSerialNumberSearch(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={12} lg={3}>
          <TextField
            label="E-mail Search"
            onChange={(e) => setEmailSearch(e.target.value)}
          />
        </Grid>
      </Grid>
      <br />
      <br />

      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <Paper>
            <Container>
              <br />
              {isLoading && <CircularProgress color="secondary" />}

              <Table style={{ tableLayout: "auto" }}>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      Serial Number
                    </TableCell>
                    <TableCell>CoreID</TableCell>
                    <TableCell>SO-</TableCell>
                    <TableCell>Sub</TableCell>
                    <TableCell>
                      Owner
                    </TableCell>
                    <TableCell>Contacted</TableCell>
                    <TableCell>Contact Timestamp</TableCell>
                    <TableCell>Repl SN</TableCell>
                    <TableCell>Repl SO</TableCell>
                    <TableCell>
                      Received
                    </TableCell>
                    <TableCell>Reworked</TableCell>
                  </TableRow>
                </TableHead>
                {!isLoading && report ?
                  <TableBody>
                    {report.map((result, key) => (
                      <TableRow key={key}>
                        <TableCell>
                          <NavLink
                            to={"/device/" + result._id}
                            className="Nav_link"
                          >
                            {result.serialNumber.replace(".", "").match(/.{3}/g).join(".")}
                          </NavLink>
                        </TableCell>
                        <TableCell>
                          {result.coreID ? (
                            result.coreID
                          ) : (
                            <div>-</div>
                          )}
                        </TableCell>
                        <TableCell>
                          {result.SO ? result.SO : "-"}
                        </TableCell>
                        <TableCell>
                          {result.subscription ? result.subscription : "-"}
                        </TableCell>
                        <TableCell>
                          {result.owner ? result.owner : "-"}
                        </TableCell>
                        <TableCell>{result.contacted.toString()}</TableCell>
                        <TableCell>
                          {result.contactTimestamp ?
                            <Moment>
                              {result.contactTimestamp}
                            </Moment> : <Button
                              variant="contained"
                              color={error ? "secondary" : "primary"}
                              style={{ margin: "10px" }}
                              onClick={() =>
                                handleContactButtonPress(result.serialNumber)
                              }
                              disabled={isLoading}
                            >
                              Contacted?
                            </Button>}
                        </TableCell>
                        <TableCell>
                          {result.replacementSerialNumber ? result.replacementSerialNumber : "-"}
                        </TableCell>
                        <TableCell>
                          {result.replacementSO ? result.replacementSO : "-"}
                        </TableCell>

                        <TableCell>{<Button
                          variant="contained"
                          color={error ? "secondary" : "primary"}
                          style={{ margin: "10px" }}
                          onClick={() =>
                            handleRecievedPress(result.serialNumber)
                          }
                          disabled={isLoading || result.received}
                          className={result.received ? "buttonSuccess" : ""}
                        >
                          {result.received ? result.received.toString() : "Receieved?"}
                        </Button>}</TableCell>

                        <TableCell>{<Button
                          variant="contained"
                          color={error ? "secondary" : "primary"}
                          style={{ margin: "10px" }}
                          onClick={() =>
                            handleReworkedPress(result.serialNumber)
                          }
                          disabled={isLoading || result.reworked}
                          className={result.reworked ? "buttonSuccess" : ""}
                        >
                          {result.reworked ? result.reworked.toString() : "False"}
                        </Button>}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody> : null}
              </Table>
            </Container>
            {skip !== 0 && (
              <IconButton onClick={previousPage}>
                <ArrowBackIcon />
              </IconButton>
            )}
            {report.length !== 0 && take === report.length && (
              <IconButton onClick={nextPage}>
                <ArrowForwardIcon />
              </IconButton>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default BadShuttieReport;
